import React from 'react';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface MobileButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'destructive' | 'ghost';
    size?: 'default' | 'lg' | 'sm';
    isLoading?: boolean;
    icon?: React.ReactNode;
}

export function MobileButton({
    children,
    variant = 'primary',
    size = 'default',
    isLoading = false,
    icon,
    className,
    disabled,
    ...props
}: MobileButtonProps) {
    const variantClasses = {
        primary: 'bg-primary text-primary-foreground active:bg-primary/90',
        secondary: 'bg-secondary text-secondary-foreground active:bg-secondary/80',
        destructive: 'bg-destructive text-destructive-foreground active:bg-destructive/90',
        ghost: 'bg-transparent text-foreground active:bg-accent',
    };

    const sizeClasses = {
        default: 'h-12 px-6 text-base',
        lg: 'h-14 px-8 text-lg',
        sm: 'h-10 px-4 text-sm',
    };

    return (
        <button
            className={cn(
                'inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                'disabled:opacity-50 disabled:pointer-events-none',
                variantClasses[variant],
                sizeClasses[size],
                className
            )}
            disabled={disabled || isLoading}
            {...props}
        >
            {isLoading ? (
                <Loader2 className="h-5 w-5 animate-spin" />
            ) : icon ? (
                <span className="flex-shrink-0">{icon}</span>
            ) : null}
            {children}
        </button>
    );
}
